import { useEffect, useState } from 'react';
import { storeOnSyncStatus, onBindingChange } from '../store/canvas-store';
import { isLiveSyncEnabled } from '../projects/liveSync';
import type { SyncStatus } from '../store/ydoc/provider';

/** UI-level connection state. `null` when live sync is off (no provider → no
 *  status to show). */
export type ConnectionState = SyncStatus | null;

/**
 * Subscribe to the sync provider's connection status via the canvas-store seam,
 * re-subscribing when load() rebinds. Returns null when live sync is disabled
 * (local/REST-only) so callers can hide the pill entirely.
 */
export function useSyncStatus(): ConnectionState {
  const [status, setStatus] = useState<ConnectionState>(() => (isLiveSyncEnabled() ? 'connecting' : null));

  useEffect(() => {
    if (!isLiveSyncEnabled()) { setStatus(null); return; }
    let unsubStatus: (() => void) | null = null;
    const attach = (): void => {
      unsubStatus?.();
      unsubStatus = storeOnSyncStatus((s) => setStatus(s));
    };
    attach();
    const unbind = onBindingChange(attach);
    return () => { unsubStatus?.(); unbind(); };
  }, []);

  return status;
}
